/* bloomerie Barkarte (09.10.2026): Desktop-Mega-Menue, Mobil-Drawer und Suche im Header. */
(() => {
  const desktop = window.matchMedia('(min-width: 990px)');

  /* ---------- Desktop: Mega-Panels oeffnen per Hover, Tap oder Tastatur ---------- */
  class BlNav extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.openItem = null;
      this.timer = null;
      this.touch = false;

      this.querySelectorAll('.bl-nav__item--panel').forEach((item) => {
        const trigger = item.querySelector('[data-bl-trigger]');
        item.addEventListener('mouseenter', () => {
          if (!this.touch) this.schedule(item, this.openItem ? 40 : 110);
        });
        item.addEventListener('mouseleave', () => {
          if (!this.touch) this.schedule(null, 220);
        });
        trigger.addEventListener('pointerdown', (e) => {
          this.touch = e.pointerType !== 'mouse';
        });
        trigger.addEventListener('click', (e) => {
          if (this.touch && this.openItem !== item) {
            e.preventDefault();
            this.open(item);
          }
        });
        trigger.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown' || e.key === ' ') {
            e.preventDefault();
            this.open(item);
            const first = item.querySelector('.bl-panel a');
            if (first) first.focus();
          }
        });
        item.addEventListener('focusout', (e) => {
          if (!item.contains(e.relatedTarget) && this.openItem === item) this.close();
        });
      });

      this.querySelectorAll('.bl-nav__item:not(.bl-nav__item--panel)').forEach((item) => {
        item.addEventListener('mouseenter', () => {
          if (!this.touch && this.openItem) this.schedule(null, 120);
        });
      });

      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || !this.openItem) return;
        const trigger = this.openItem.querySelector('[data-bl-trigger]');
        this.close();
        trigger.focus();
      });
      document.addEventListener('click', (e) => {
        if (this.openItem && !this.contains(e.target)) this.close();
      });
      window.addEventListener('resize', () => this.openItem && this.notch(this.openItem));
    }

    schedule(item, delay) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => (item ? this.open(item) : this.close()), delay);
    }

    open(item) {
      clearTimeout(this.timer);
      if (this.openItem === item) return;
      const swap = Boolean(this.openItem);
      this.classList.toggle('is-swapping', swap);
      if (this.openItem) this.release(this.openItem);
      this.openItem = item;
      this.notch(item);
      item.classList.add('is-open');
      item.querySelector('[data-bl-trigger]').setAttribute('aria-expanded', 'true');
      document.body.classList.add('bl-nav-open');
    }

    close() {
      clearTimeout(this.timer);
      if (!this.openItem) return;
      this.release(this.openItem);
      this.openItem = null;
      this.classList.remove('is-swapping');
      document.body.classList.remove('bl-nav-open');
    }

    release(item) {
      item.classList.remove('is-open');
      item.querySelector('[data-bl-trigger]').setAttribute('aria-expanded', 'false');
    }

    notch(item) {
      const panel = item.querySelector('.bl-panel');
      const trigger = item.querySelector('[data-bl-trigger]');
      if (!panel) return;
      const p = panel.getBoundingClientRect();
      const t = trigger.getBoundingClientRect();
      panel.style.setProperty('--bl-notch', `${Math.round(t.left + t.width / 2 - p.left)}px`);
    }
  }

  /* ---------- Mobil: Drawer mit Akkordeon ---------- */
  class BlDrawer extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.toggleButton = this.querySelector('[data-bl-drawer-toggle]');
      this.drawer = this.querySelector('.bl-drawer');
      this.drawer.inert = true;

      this.toggleButton.addEventListener('click', () => (this.isOpen ? this.close() : this.open()));
      this.querySelectorAll('[data-bl-drawer-close]').forEach((b) => b.addEventListener('click', () => this.close(true)));
      this.drawer.addEventListener('click', (e) => {
        if (e.target === this.drawer) this.close(true);
      });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) this.close(true);
      });

      this.querySelectorAll('.bl-acc__btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const acc = btn.closest('.bl-acc');
          const willOpen = !acc.classList.contains('is-open');
          this.querySelectorAll('.bl-acc.is-open').forEach((o) => {
            o.classList.remove('is-open');
            o.querySelector('.bl-acc__btn').setAttribute('aria-expanded', 'false');
          });
          acc.classList.toggle('is-open', willOpen);
          btn.setAttribute('aria-expanded', String(willOpen));
        });
      });

      desktop.addEventListener('change', () => this.isOpen && this.close());
    }

    open() {
      this.isOpen = true;
      this.drawer.inert = false;
      this.classList.add('is-open');
      this.toggleButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('bl-lock');
      const search = document.querySelector('bl-search');
      if (search) search.close();
      setTimeout(() => this.querySelector('.bl-drawer__close').focus({ preventScroll: true }), 60);
    }

    close(focusToggle = false) {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('is-open');
      this.toggleButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('bl-lock');
      this.drawer.inert = true;
      if (focusToggle) this.toggleButton.focus({ preventScroll: true });
    }
  }

  /* ---------- Suche: runde Leiste faehrt aus der Lupe ---------- */
  class BlSearch extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.toggleButton = this.querySelector('.bl-search__toggle');
      this.input = this.querySelector('input[type="search"]');
      this.form = this.querySelector('form');
      this.ps = this.querySelector('.bl-search__ps');

      this.toggleButton.addEventListener('click', () => (this.isOpen ? this.close(true) : this.open()));
      this.querySelector('[data-bl-search-close]').addEventListener('click', () => this.close(true));
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) this.close(true);
      });
      this.addEventListener('click', (e) => {
        // "Suche nach ..." liegt ausserhalb des Formulars, deshalb selbst absenden
        if (e.target.closest('.predictive-search__item--term')) {
          e.preventDefault();
          if (this.input.value.trim()) this.form.submit();
        }
      });
      document.addEventListener('click', (e) => {
        if (this.isOpen && !this.contains(e.target)) this.close();
      });
    }

    open() {
      this.isOpen = true;
      this.classList.add('is-open');
      this.toggleButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('bl-search-open');
      const nav = document.querySelector('bl-nav');
      if (nav) nav.close();
      this.input.focus({ preventScroll: true });
    }

    close(focusToggle = false) {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('is-open');
      this.toggleButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('bl-search-open');
      if (this.ps && typeof this.ps.close === 'function') this.ps.close();
      if (focusToggle) this.toggleButton.focus({ preventScroll: true });
      else if (this.contains(document.activeElement)) document.activeElement.blur();
    }
  }

  if (!customElements.get('bl-nav')) customElements.define('bl-nav', BlNav);
  if (!customElements.get('bl-drawer')) customElements.define('bl-drawer', BlDrawer);
  if (!customElements.get('bl-search')) customElements.define('bl-search', BlSearch);
})();
